import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../constants/animationVariants';
import { Expertise } from '../../types/expertise';
import { Language } from '../../types/languages';
import ProfileConfigInfo from './ProfileConfigInfo';
import ServiceExpertise from './ServiceExpertise';
import SpecializedLanguages from './SpecializedLanguages';

const CorporateInfo = ({
  expertiseList,
  languages,
}: {
  expertiseList: Array<Expertise>;
  languages: Array<Language>;
}) => {
  // rendering corporate info section component here
  return (
    <motion.section
      variants={sectionAnimVariants}
      initial='initial'
      animate='animate'
      className='space-y-5'
    >
      <div className='grid xl:grid-cols-2 gap-5'>
        <ServiceExpertise expertiseList={expertiseList} />

        <SpecializedLanguages languages={languages} />
      </div>

      <ProfileConfigInfo />
    </motion.section>
  );
};

export default CorporateInfo;
